import { render, staticRenderFns } from "./myrealtest.vue?vue&type=template&id=2628d57f&scoped=true"
import script from "./myrealtest.vue?vue&type=script&lang=js"
export * from "./myrealtest.vue?vue&type=script&lang=js"
import style0 from "./myrealtest.vue?vue&type=style&index=0&id=2628d57f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2628d57f",
  null
  
)

export default component.exports